import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=1b082344&scoped=true&"
import script from "./QuestionDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=1b082344&prod&lang=scss&scoped=true&"
import style1 from "./QuestionDetail.vue?vue&type=style&index=1&id=1b082344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b082344",
  null
  
)

export default component.exports